import React from 'react'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import HighIntentOffersCarousel from 'components/OfferList/HighIntent/HighIntentOffersCarousel'
import Heading from 'components/Luxkit/Typography/Heading'

interface Props {
  highIntentOffers: Array<App.HighIntentOffer>
}

function FrontPageHighIntentOffers(props: Props) {
  const { highIntentOffers } = props

  return <VerticalSpacer gap={12}>
    <Heading variant="heading5">Still interested in these offers?</Heading>
    <HighIntentOffersCarousel
        highIntentOffers={highIntentOffers}
        analyticsLabel="all offers"
      />
  </VerticalSpacer>
}

export default FrontPageHighIntentOffers
